export default "f2601c6c9f5e6f98.png"